<script>
  import { createEventDispatcher } from "svelte";
  import backend from "../../../../server";

  const dispatch = createEventDispatcher();

  let client_id = "";
  let new_endpoint = "";
  let loading = false;

  async function updateEndpoint() {
    if (!client_id || !new_endpoint) {
      alertify.error("Complete ambos campos antes de continuar");
      return;
    }

    loading = true;
    try {
      const payload = { client_id, new_endpoint };
      const response = await backend.client.updateEndpoint(payload);
      console.log("Respuesta:", response.data);
      alertify.success("✅ Endpoint actualizado correctamente");
      closeModal();
    } catch (err) {
      console.error(err);
      alertify.error("❌ Error al actualizar el endpoint");
    } finally {
      loading = false;
    }
  }

  function closeModal() {
    dispatch("close");
  }
</script>

<div class="modal">
  <div class="modal-content">
    <h3>Actualizar Endpoint</h3>

    <label>ID del Cliente</label>
    <input type="text" bind:value={client_id} placeholder="Ej. 123" />

    <label>Nuevo Endpoint</label>
    <input type="text" bind:value={new_endpoint} placeholder="https://api.nuevo-endpoint.com" />

    <div class="buttons">
      <button on:click={updateEndpoint} disabled={loading}>
        {#if loading}Actualizando...{/if}
        {#if !loading}Aceptar{/if}
      </button>
      <button class="cancel" on:click={closeModal}>Cancelar</button>
    </div>
  </div>
</div>

<style>
  .modal {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
  }

  .modal-content {
    background: white;
    padding: 1.5rem;
    border-radius: 8px;
    width: 380px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  input {
    padding: 6px;
    border-radius: 4px;
    border: 1px solid #ccc;
  }

  .buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }

  button {
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    background-color: #007BFF;
    color: white;
    font-weight: 500;
  }

  .cancel {
    background-color: #dc3545;
  }
</style>